import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { AuthProvider } from "@/lib/auth";
import { AppRouter } from "@/router";
import { initSentry } from "@/lib/sentry";
import { queryClient } from "@/lib/queries";

import "@/App.css";

/**
 * Root component — boots Sentry, wraps the router in AuthProvider + React
 * Query, mounts the global Sonner toast host. HelmetProvider is at the
 * top so any page (notably the public Digital Business Card) can override
 * <head> meta tags for browser + dev-tools link previews.
 */
function App() {
  useEffect(() => {
    initSentry();
  }, []);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster
              theme="dark"
              position="top-center"
              richColors
              closeButton
              toastOptions={{
                classNames: {
                  toast:
                    "bg-card text-foreground border border-border shadow-soft rounded-xl",
                  title: "text-sm font-semibold",
                  description: "text-sm text-muted-foreground",
                },
              }}
            />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
